module.exports = __webpack_public_path__ + "static/img/big_vote_A.018ee06.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/imgs/vote/big_vote_A.png
// module id = xhAI
// module chunks = 1